import { render, staticRenderFns } from "./MaterialGuidCreate.vue?vue&type=template&id=12f43634"
import script from "./MaterialGuidCreate.vue?vue&type=script&lang=js"
export * from "./MaterialGuidCreate.vue?vue&type=script&lang=js"
import style0 from "./MaterialGuidCreate.vue?vue&type=style&index=0&id=12f43634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports